import { Col } from "reactstrap";
import { useAvailableModulesContext } from '../../context/AvailableModulesContext';

function Banner() {
    const { reactAppName } = useAvailableModulesContext();

    return <Col lg={6} style={{
        backgroundColor: "var(--main-color)",
        display: "flex",
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center"
    }}>
        <label className="siteLogo">{reactAppName}</label>
    </Col>;
}

export default Banner;